export const identificadorParse = (id, tipoIdentificador) => {
  /**
   * id do CPF e CNPJ com espaços em branco
   */
  if (id !== '           ' && id !== '              ') {
    if (tipoIdentificador === 'CPF') {
      const valor = id.substr(0, 3) + '.' + id.substr(3, 3) + '.' + id.substr(6, 3) + '-' + id.substr(9, 2)
      if (valor !== '..-') {
        return {
          value: valor
        }
      }
    }

    if (tipoIdentificador === 'CNPJ') {
      return {
        value: id.substr(0, 2) + '.' + id.substr(2, 3) + '.' + id.substr(5, 3) + '/' + id.substr(8, 4) + '-' + id.substr(12, 2)
      }
    }
    return {
      value: id
    }
  } else {
    return {
      value: '-'
    }
  }
}
